import { getSurvey } from '@/shared/lib/getSurvey';
import { Survey } from '@/shared/types/Survey';
import { SurveyStatus } from '@/shared/types/User';

import { useCurrentUser } from './useCurrentUser';
import { useUserSettings } from './useSettings';

export const useSurvey = (id: Survey['id']) => {
  const { surveys } = useUserSettings();
  const { data: user } = useCurrentUser();
  const targetSurvey = getSurvey(surveys, id);

  if (!user || !surveys || !targetSurvey) {
    return { isSurveyCompleted: true, isSurveyRejected: false, shouldCompleteSurvey: false };
  }

  const userSurvey = user?.surveys.find((survey) => survey.id === targetSurvey?.id);
  const isSurveyCompleted = Boolean(userSurvey?.status === SurveyStatus.Completed);
  const isSurveyRejected = Boolean(userSurvey?.status === SurveyStatus.Rejected);

  const shouldCompleteSurvey = !isSurveyCompleted;

  return { isSurveyCompleted, isSurveyRejected, shouldCompleteSurvey };
};
